// Career Intelligence — funnel analytics. Reuses the platform web-analytics writer
// (POST /api/web/track → web_events); no new pipeline. Fire named `career_*` events at
// the key funnel steps so acquisition (TikTok/IG → tester → signup → checkout) is
// measurable. Best-effort and non-blocking — analytics must never break the funnel.

import { supabase } from "@/lib/supabaseClient"

export async function trackCareer(event: string, properties: Record<string, unknown> = {}): Promise<void> {
  if (typeof window === "undefined") return
  try {
    const headers: Record<string, string> = { "Content-Type": "application/json" }
    try {
      const { data } = await supabase.auth.getSession()
      const token = data.session?.access_token
      if (token) headers.Authorization = `Bearer ${token}`
    } catch { /* signed-out is fine — most funnel events are anonymous */ }
    await fetch("/api/web/track", {
      method: "POST",
      headers,
      keepalive: true, // let it complete across the navigation the event often precedes
      body: JSON.stringify({
        path: window.location.pathname,
        event_type: `career_${event}`,
        properties,
      }),
    })
  } catch {
    /* never throw from analytics */
  }
}
